import axios, { AxiosResponse } from "axios";
import { handleApiError } from "src/common/api/apiErrorHandler";

export default class AuthApi {
  static async authenticate(username: string, password: string): Promise<string> {
    return axios
      .post("./api/Authorization/Login", {
        username,
        password
      })
      .then(
        (response: AxiosResponse): string => {
          return response.data;
        }
      )
      .catch(error => {
        return handleApiError(error);
      });
  }
}
